module.exports = __webpack_public_path__ + "static/img/contact_phone.1784115679763.png";